import { boolean, number, object } from 'yup';
import { WizardState } from '../../../../context/SetGoalProvider';

export type FormValues = WizardState['purchase'];

export const validation = object({
  amount: number()
    .nullable()
    .required('Please, specify an amount'),
  inflation: number()
    .nullable()
    .required('Please, specify the inflation'),
  isRecurringPurchase: boolean(),
  oneTimeOptions: object()
    .nullable()
    .when('isRecurringPurchase', {
      is: val => !val,
      then: object({
        targetYear: number()
          .nullable()
          .required('Please, select an option'),
      }),
    }),
  recurringOptions: object()
    .nullable()
    .when('isRecurringPurchase', {
      is: true,
      then: object({
        startYear: number()
          .nullable()
          .required('Required'),
        repeatEvery: number()
          .nullable()
          .required('Required'),
        repeatFor: number()
          .nullable()
          .required('Required'),
      }),
    }),
});
